import { ModelHelper } from '../classes/model-helper';
import { LabLockState } from '../enums/lab-lock-state.enum';
import { Company } from './company.model';

export class LabLockEntry {
	// Activation date
	activationDate: Date;

	// Dentist
	dentist: Company;

	// Inventory number
	inventoryNumber: string;

	// Company
	lab: Company;

	// Lab lock state
	labLockState: LabLockState;

	// UID
	uid: string;

	// Workstation ID
	workstationId: string;

	/**
	 * Static mapping function
	 */
	static map(data: any, item: LabLockEntry = new LabLockEntry()): LabLockEntry {
		return item.map(data);
	}

	/**
	 * Non static mapping function
	 */
	public map(data: any): LabLockEntry {
		ModelHelper.map(data, this, 'activationDate', Date);
		ModelHelper.map(data, this, 'dentist', Company);
		ModelHelper.map(data, this, 'lab', Company);
		ModelHelper.map(data, this, 'inventoryNumber');
		ModelHelper.map(data, this, 'labLockState');
		ModelHelper.map(data, this, 'uid');
		ModelHelper.map(data, this, 'workstationId');

		return this;
	}

	/**
	 * Prepare lab lock entry data for api
	 */
	public getDataForApi(data: any = this): any {
		// Clone data
		const apiData: any = LabLockEntry.map(JSON.parse(JSON.stringify(data)));

		// Process properties
		for (const [key, value] of Object.entries(apiData)) {
			// Check for own getDataForApi method
			if (value && (<any>value).getDataForApi) {
				apiData[key] = (<any>value).getDataForApi();
			} else {
				apiData[key] = JSON.parse(JSON.stringify(value));
			}
		}

		return apiData;
	}
}
